import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import styles from './signup-form.module.css';

type Props = {
    imgSrc: string;
    officialPartner: boolean;
};

export function SignupCustomHeader(props: Props) {
    return (
        <div className='pb-16'>
            <StackLegacy spacing={16} alignCenter={true}>
                <div className={styles['partner-logo']}>
                    <img
                        src={props.imgSrc}
                        alt=''
                        onError={(e) => {
                            e.currentTarget.style.display = 'none'; // Hide image if no logo is found
                        }}
                    />
                </div>
                {props.officialPartner && (
                    <StackLegacy spacing={6} alignCenter={true}>
                        <img
                            src='/include/images/nutshell-logo-full-color.svg'
                            alt=''
                            height={20}
                        />
                        <Body>OFFICIAL PARTNER</Body>
                    </StackLegacy>
                )}
            </StackLegacy>
        </div>
    );
}
